import React, { Component } from 'react';
import './index.css';

import Fieldlist from '../Fieldlist'
import ExpenditureFilter from '../ExpenditureFilter'
import SortControl from '../SortControl'
import CategoryFilter from '../CategoryFilter'
import InfoButton from './InfoButton'

class Controls extends Component {

  render() {
    // <DateFilter />
    return (
      <div className="controls no-select">
        <div className="title-container">
          <div className="title">Brexplorer</div>
        </div>
        <div className="control">
          <Fieldlist />
        </div>
        <div className="control">
          <ExpenditureFilter />
        </div>
        <div className="control">
          <SortControl />
        </div>
        <div className="control">
          <CategoryFilter />
        </div>
        <div className="info-button">
          <InfoButton />
        </div>
      </div>
    )
  }
}

export default Controls;



// WEBPACK FOOTER //
// ./src/Controls/index.js